import type { ReactElement } from 'react'

import { IR_STOCK_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

export const StockPage = () => {
  return (
    <Layout>
      <SectionTitle color="normal" enTitleText="Stock Information" subTitleText="" />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_STOCK_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...rest }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...rest}
              key={path}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}

StockPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Stock Information', path: '' },
  ]

  return (
    <>
      <Head
        title="Stock Information"
        description="Stock Information"
        ogp={{ url: 'en/ir/stock' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
